import { Box, Card, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormType } from '@/api/enum/formType.enum';
import { useState } from 'react';
import StaffInfoForm from './components/StaffInfoForm';

export default function CreateStaffPage() {
	const { t } = useTranslation();
	const [type, setType] = useState<FormType>(FormType.create);
	return (
		<>
			<Box sx={{ width: '100%' }}>
				<Box>
					<Typography variant='h4'>{t('staff.addStaffAccount')}</Typography>
					<Card sx={{ marginTop: 3 }}>
						<StaffInfoForm type={type} setType={setType} />
					</Card>
				</Box>
			</Box>
		</>
	);
}
